import {Box, Grid, Modal, Popover, Typography} from '@mui/material';
import {ISearchForm} from '@/interfaces/bookingContext';
import {ModalGuests} from '../modal/ModalGuests';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {makeStyles} from 'tss-react/mui';
import {AppContext} from '@/utils/appContext';
import {useTranslation} from 'react-i18next';
import {Users} from '@vectopus/atlas-icons-react';
import {useResponsive} from '@/hooks/use-responsive';
import {website} from "@/utils/helpers";

const SetGuestsField = (props: any) => {
  const appContext = useContext(AppContext);
  const {classes} = useStyles();
  const {t} = useTranslation();

  const [guestConfirmed, setGuestConfirmed] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [openGuestsModal, setOpenGuestsModal] = useState(false);

  const initialGuestsRef = useRef<ISearchForm[]>([]);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    initialGuestsRef.current = appContext.searchForms.map(form => ({
      ...form,
      ageOfChildren: [...form.ageOfChildren] // Deep copy array
    }));

    setAnchorEl(event.currentTarget);
    setOpenGuestsModal(true);
  };

  const [ageChildrenAlert, setAgeChildrenAlert] = useState<boolean>(false)
  const handleCloseGuestsModal = () => {
    setGuestConfirmed(true);
    const mergedChildsArray = mergeChildFromAccommodations(appContext.searchForms);
    if(!mergedChildsArray.ageOfChildren.includes(-1)){
      sumGuests();

      const guestsChanged = checkGuestsChanged();
      if (guestsChanged && window.isBookingOnlinePage) {
        appContext.getAvailability(appContext.orderIndex);
      }

      setOpenGuestsModal(false);
      setAgeChildrenAlert(false);
    } else {
      setAgeChildrenAlert(true);
      /*toast.warning(t('selezionare_eta_dei_bambini'));*/
    }
  };

  const checkGuestsChanged = () => {
    if (initialGuestsRef.current.length !== appContext.searchForms.length) {
      return true; // Accommodation count changed
    }

    return appContext.searchForms.some((form, index) => {
      const initial = initialGuestsRef.current[index];
      if (!initial) return true;
      if (form.NoOfAdults !== initial.NoOfAdults) return true;
      if (form.Pets !== initial.Pets) return true;
      if (form.ageOfChildren.length !== initial.ageOfChildren.length) return true;
      return form.ageOfChildren.some((age, i) => age !== initial.ageOfChildren[i]);
    });
  };

  function mergeChildFromAccommodations(arr: any[]) {
    const result: any = {};

    arr.forEach((obj: any) => {
      for (const prop in obj) {
        if (Array.isArray(obj[prop])) {
          if (!result[prop]) {
            result[prop] = [];
          }
          result[prop].push(...obj[prop]);
        }
      }
    });
    return result;
  }

  const [howGuests, setHowGuests] = useState<number>(0);
  const [howPets, setHowPets] = useState<number>(0);

  const sumGuests = () => {
    let count = 0;
    appContext.searchForms.forEach((sF: ISearchForm) => {
      count += sF.NoOfAdults;
      count += sF.ageOfChildren.length;
    });
    return count;
  };

  const sumPets = () => {
    let count = 0;
    appContext.searchForms.forEach((sF: ISearchForm) => {
      count += sF.Pets;
    });
    return count;
  };

  useEffect(() => {
    setHowGuests(sumGuests);
    setHowPets(sumPets);
  }, [appContext.searchForms]);

  const setQuantity = props.params.setQuantity;
  const setPets = props.params.setPets;

  const addSearchForm = () => {
    const searchForms = [...appContext.searchForms];
    searchForms.push({
      property: searchForms[appContext.orderIndex].property,
      destination: searchForms[appContext.orderIndex].destination,
      GuestArrival: searchForms[appContext.orderIndex].GuestArrival,
      GuestDeparture: searchForms[appContext.orderIndex].GuestDeparture,
      NoOfAdults: 2,
      ageOfChildren: [],
      Child: undefined,
      typeOfHoliday: '',
      landscape: '',
      Coupon: searchForms[appContext.orderIndex].Coupon,
      Pets: 0,
      // status: 'to_start',
      autoSearch: false
    });
    appContext.setSearchForms(searchForms);
  };

  const removeSearchForm = (index: number) => {
    const searchForms = [...appContext.searchForms];
    searchForms.splice(index, 1);
    appContext.setSearchForms([...searchForms]);
  };


  const handlePopoverClose = () => {
    setGuestConfirmed(true);
    const mergedChildsArray = mergeChildFromAccommodations(appContext.searchForms);
    if(!mergedChildsArray.ageOfChildren.includes(-1)){
      setAnchorEl(null);
      setAgeChildrenAlert(false);
      const guestsChanged = checkGuestsChanged()
      if (guestsChanged && window.isBookingOnlinePage) {
        appContext.getAvailability(appContext.orderIndex);
      }
    } else {
      setAgeChildrenAlert(true);
    }
  };

  const open = Boolean(anchorEl);
  const container = props.params.container;

  const downSm = useResponsive('down', 'sm');
  const upMd = useResponsive('up', 'md');
  const downMd = useResponsive('down', 'md');

  const acc = appContext.searchForms.length > 1 ? t('accommodations') : t('accommodation');

  return (
    <>
      <Grid
        size={{ xs: 12, sm: 'auto' } as const}
        id={'selectGuests'}
        className={classes.inputPaper}
        onClick={handlePopoverOpen}>
        <Box
          id={'fieldContent'}
          className={
            container === 'SearchBarMobile' ? classes.fieldContent2 : classes.fieldContent
          }>
          {
            container !== 'DrawerSearchWidget' && (
              <Box sx={{ height: 24 }}>
                <Users size={18}/>
              </Box>
            )
          }

          {
            container === 'DrawerSearchWidget' ? (
              <>
                  {/*guestConfirmed ? (*/}
                    <Typography
                        variant={'h6'}
                        component={'h6'}
                        className={classes.selectedGuests}
                    >
                      {howGuests}{' '}
                      {container === 'DrawerSearchWidget' &&
                          t('guests') + ', ' +
                          appContext.searchForms.length + ' ' + acc
                      }
                    </Typography>
                  {/*) : (
                    <Typography
                        variant={'h6'}
                        component={'h6'}
                    >{t('Select_guests_placeholder')}</Typography>
                  )*/}
              </>
            ) : (
                <Typography
                    variant={'h6'}
                    component={'h6'}
                    className={classes.selectedGuests}
                >
                  {howGuests}{' '}
                  {container === 'DrawerSearchWidget' && t('guests')}
              </Typography>
            )
          }

          {
            container === 'DrawerSearchWidget' && (
              <Box pr={1} sx={{ position: 'absolute', right: 5, display: 'flex', alignItems: 'center' }}>
                <Users size={18}/>
              </Box>
            )
          }

        </Box>
      </Grid>

      {
        downMd && (
          <Modal
            open={openGuestsModal}
            onClose={handleCloseGuestsModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={modal}>
            <>
              <ModalGuests
                params={{
                  container,
                  ageChildrenAlert,
                  setAgeChildrenAlert,
                  openGuestsModal,
                  handleCloseGuestsModal,
                  setQuantity,
                  setPets,
                  sumGuests,
                  sumPets,
                  addSearchForm,
                  removeSearchForm,
                  handlePopoverClose
                }}
              />
            </>
          </Modal>
        )
      }

      {
        upMd && container === 'DrawerSearchWidget' && (
          <Modal
            open={openGuestsModal}
            onClose={handleCloseGuestsModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={modalInsideDrawer}>
            <>
              <ModalGuests
                params={{
                  container,
                  ageChildrenAlert,
                  setAgeChildrenAlert,
                  openGuestsModal,
                  handleCloseGuestsModal,
                  setQuantity,
                  setPets,
                  sumGuests,
                  sumPets,
                  addSearchForm,
                  removeSearchForm,
                  handlePopoverClose
                }}
              />
            </>
          </Modal>
        )
      }

      {
        upMd && container !== 'DrawerSearchWidget' && (
          <Popover
              onClose={handlePopoverClose}
              open={open}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              className={classes.popoverContainer}>
            <Box sx={{maxWidth: 420}}>
              <ModalGuests
                  params={{
                    container,
                    ageChildrenAlert,
                    setAgeChildrenAlert,
                    openGuestsModal,
                    handleCloseGuestsModal,
                    setQuantity,
                    setPets,
                    sumGuests,
                    sumPets,
                    addSearchForm,
                    removeSearchForm,
                    handlePopoverClose
                  }}
              />
            </Box>
          </Popover>
        )
      }
    </>
  );
};

export default SetGuestsField;

const useStyles = makeStyles()((theme) => {
  return {
    fieldContent: {
      backgroundColor: website.code === 'VP' ? '#FFFFFF' : '#f5f5f5',
      border: website.code === 'VP' ? '1px solid #D9D9D9' : 'none',
      position: 'relative',
      padding: '16px 12px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: theme.radius.formBorderRadius,
      cursor: 'pointer',
      i: {
        fontSize: 26
      },
      [theme.breakpoints.down('md')]: {
        backgroundColor: '#fff',
        justifyContent: 'text-start'
      },
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        backgroundColor: '#fff'
      }
    },
    fieldContent2: {
      backgroundColor: website.code === 'VP' ? '#FFFFFF!important' : '#f5f5f5',
      border: website.code === 'VP' ? '1px solid #D9D9D9' : 'none',
      padding: website.code === 'VP' ? '15px 4px' : '16px 12px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: theme.radius.formBorderRadius,
      i: {
        fontSize: 26
      },
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
        backgroundColor: '#f5f5f5'
      }
    },
    selectedGuests: {
      color: '#000!important',
      fontFamily: theme.typography.body1.fontFamily
    },
    inputPaper: {
      backgroundColor: '#FFF',
      borderRadius: theme.radius.formBorderRadius,
      h6: {
        fontSize: 14,
        /*fontFamily: theme.typography.h2.fontFamily,*/
        color: '#9B9B9B'
      }
    },
    popoverContainer: {
      height: '100%',
      '& .MuiBox-root': {
        minWidth: 'auto!important'
      },
      '& .MuiBackdrop-root': {
        backgroundColor: '#000000',
        opacity: '0.4!important'
      }
    }
  };
});

const modal = {
  backgroundColor: '#FFF',
  '.MuiBackdrop-root': {
    backgroundColor: '#FFF'
  }
};

const modalInsideDrawer = {
  width: 470,
  left: 'inherit',
  backgroundColor: '#FFF',
  overflow: 'hidden',
  '.MuiBackdrop-root': {
    display: 'none!important'
  }
}
